import { ReactElement, useCallback } from 'react'

import { VatExemptionMentionModal } from '@features/invoicingSettings/elements/VatExemptionMentionModal'
import {
  LegalGuaranteeOfConformityModal,
  LegalMentionsModal,
  LegalSettingTypes,
} from '@features/invoicingSettings/modules/compliance'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useFormContext } from '../../../../../../../../hooks'
import { useInvoiceSettingsModals } from '../../contexts/invoiceSettingsModalsContext'
import { InvoiceSettingsFormSchema } from '../../types/invoiceSettingsFormSchema'
import { AutomaticPaymentRemindersModal } from './elements/AutomaticPaymentRemindersModal'

export const InvoiceSettingsModals = (): ReactElement | null => {
  const { automaticPaymentRemindersModal, legalMentionsModal, vatExemptionMentionModal } = useInvoiceSettingsModals()
  const { setValue } = useFormContext<InvoiceSettingsFormSchema>()

  const {
    defaultValues: automaticPaymentRemindersDefaultValues,
    isLoading: isAutomaticPaymentRemindersModalLoading,
    onSubmit: onAutomaticPaymentRemindersModalSubmit,
    variant: automaticPaymentRemindersModalVariant,
  } = automaticPaymentRemindersModal

  const {
    defaultValues: legalMentionsDefaultValues,
    onSubmit: onLegalMentionsModalSubmit,
    variant: legalMentionsModalVariant,
  } = legalMentionsModal

  const {
    defaultValue: vatExemptionMentionDefaultValue,
    isSubmitting: isUpdatingVatExemptionMention,
    onSubmit: onVatExemptionMentionModalSubmit,
  } = vatExemptionMentionModal

  const shouldShowAutomaticPaymentRemindersModal =
    !isAutomaticPaymentRemindersModalLoading && automaticPaymentRemindersDefaultValues

  const handleLegalGuaranteeOfConformityEnableChange = useCallback(
    (isEnabled: boolean) => {
      setValue(`legalFormSettings.${LegalSettingTypes.IsLegalGuaranteeOfConformity}`, isEnabled, {
        shouldDirty: true,
      })
    },
    [setValue],
  )

  return (
    <>
      {shouldShowAutomaticPaymentRemindersModal && (
        <AutomaticPaymentRemindersModal
          defaultValues={automaticPaymentRemindersDefaultValues}
          id={ModalId.AutomaticPaymentRemindersModal}
          onSubmit={onAutomaticPaymentRemindersModalSubmit}
          variant={automaticPaymentRemindersModalVariant}
        />
      )}
      <LegalMentionsModal
        defaultValues={legalMentionsDefaultValues}
        id={ModalId.LegalMentionsModal}
        onSubmit={onLegalMentionsModalSubmit}
        variant={legalMentionsModalVariant}
      />
      <LegalGuaranteeOfConformityModal
        id={ModalId.LegalGuaranteeOfConformityModal}
        onEnableChange={handleLegalGuaranteeOfConformityEnableChange}
      />
      <VatExemptionMentionModal
        defaultValue={vatExemptionMentionDefaultValue}
        id={ModalId.VatExemptionMentionModal}
        isSubmitting={isUpdatingVatExemptionMention}
        onSubmit={onVatExemptionMentionModalSubmit}
      />
    </>
  )
}
